export default {
  alerta: {},
};
